// Counts down to a fixed end time (data-end), or to the next midnight in data-timezone when data-mode="daily".
// A fixed countdown hides its announcement region once it ends; a daily one rolls over to the next day.
class SCountdown extends HTMLElement {
  #timer = null;

  connectedCallback() {
    this.mode = this.dataset.mode === 'daily' ? 'daily' : 'fixed';
    this.end = Date.parse(this.dataset.end);
    this.timeZone = this.dataset.timezone || undefined;
    if (this.mode === 'fixed' && Number.isNaN(this.end)) return;
    this.#tick();
    this.#timer = setInterval(() => this.#tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.#timer);
  }

  #secondsUntilMidnight() {
    let parts;
    try {
      parts = new Intl.DateTimeFormat('en-US', { timeZone: this.timeZone, hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' }).formatToParts(new Date());
    } catch {
      parts = new Intl.DateTimeFormat('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' }).formatToParts(new Date());
    }
    const get = (type) => Number(parts.find((p) => p.type === type)?.value || 0);
    const elapsed = get('hour') * 3600 + get('minute') * 60 + get('second');
    return Math.max(1, 86400 - elapsed);
  }

  #tick() {
    let remaining;
    if (this.mode === 'daily') {
      remaining = this.#secondsUntilMidnight();
    } else {
      remaining = Math.max(0, Math.floor((this.end - Date.now()) / 1000));
      if (remaining === 0) {
        clearInterval(this.#timer);
        const region = this.closest('[role="region"]');
        if (region) region.hidden = true;
        return;
      }
    }
    const days = Math.floor(remaining / 86400);
    const pad = (n) => String(n).padStart(2, '0');
    this.#set('days', pad(days));
    this.#set('hours', pad(Math.floor((remaining % 86400) / 3600)));
    this.#set('minutes', pad(Math.floor((remaining % 3600) / 60)));
    this.#set('seconds', pad(remaining % 60));
    const daysUnit = this.querySelector('[data-unit-wrap="days"]');
    if (daysUnit) daysUnit.hidden = days === 0;
  }

  #set(unit, value) {
    const el = this.querySelector(`[data-unit="${unit}"]`);
    if (el && el.textContent !== value) el.textContent = value;
  }
}

if (!customElements.get('s-countdown')) customElements.define('s-countdown', SCountdown);
